module.exports = __webpack_public_path__ + "media/images/cnn-6c50fa4736dfb77ea80243cf0922d9ef84ff2f09f365ac042198d2a484e4e032.jpg";